export default __webpack_public_path__ + "static/media/crmls-swoosh-pattern.623d7696.svg";